import { flagIcons, infoIcon } from "../../assets/icons";
import { BITCOINCASH_URL } from "../../constants";
import RedirectButton from "../ui/RedirectButton";
import SearchInput from "./SearchInput";
import StoreList from "./StoreList";
import { useLanguageContext } from "../../context/LanguageContext";
import { logo } from "../../assets/icons";
import { useState } from "react";
export default function SideBar({ closeMenu }) {
  const { t } = useLanguageContext();
  const [filtersOpen, setFiltersOpen] = useState(false);


  function handleBack() {
    if (filtersOpen) {
      setFiltersOpen(false);
    } else {
      closeMenu(false);
    }
  }

  return (
    <nav className="w-full sm:w-96 h-dvh bg-gray-900 absolute top-0 flex flex-col px-2">
      <section className="h-16 flex-shrink-0 flex flex-row justify-between items-center text-white mx-2">
        <button
          className="inline-flex items-center gap-1.5 h-8 px-2 rounded-md border border-slate-600 text-xs text-slate-200 hover:bg-slate-800"
          onClick={() => handleBack()}
          aria-label="Mapa"
          title="Mapa"
        >
          <svg
            className="w-4 h-4"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M15 18l-6-6 6-6" />
          </svg>
          <span>{t("component", "sidebar", "map")}</span>
        </button>
        <a className="flex flex-row items-center cursor-pointer w-full justify-center gap-3" href={BITCOINCASH_URL} target="_blank">
          <div className="h-8 w-8">{logo}</div>
          <h1>Bitcoin Cash</h1>
        </a>
        <a className="text-sub_text_color hover:text-white cursor-pointer" href="/about">
          {infoIcon}
        </a>
      </section>

      <div className=" flex flex-col overflow-hidden">
        <SearchInput filtersOpen={filtersOpen} setFiltersOpen={setFiltersOpen} />

        {!filtersOpen && (
          <>
            <StoreList />
            <div className="mb-2 mt-3">

            <RedirectButton href="/join" title={t("component", "sidebar", "buttonAddStore")} />
            <p className="text-xs text-gray-400 flex flex-row items-center justify-center pt-2">Made in BCH Argentina {flagIcons.es}</p>
            </div>
          </>
        )}
      </div>
    </nav>
  );
}
